import axios from 'axios'

const apiOrigin = process.env.VUE_APP_BASE_URL || ''

let baseURL = `${apiOrigin}/api/v1/customers`
if (localStorage.getItem('userInfo')) {
  if (JSON.parse(localStorage.getItem('userInfo')).data.user.type === 1) {
    baseURL = `${apiOrigin}/api/v1/publishers`
  }
} else {
  let address = window.location.href.split('/')
  if (address[4] === 'publisher') {
    baseURL = `${apiOrigin}/api/v1/publishers`
  }
}

export default axios.create({
    baseURL,
})
